/**
 * 앱 모드 설정
 * PG 심사를 위한 임시 '쇼핑몰' 모드와 실제 '경매' 모드를 전환
 */

export type AppMode = 'AUCTION' | 'SHOPPING';

/**
 * 현재 앱 모드
 * - AUCTION: 경매/입찰 모드 (원본)
 * - SHOPPING: 구매 모드 (PG 심사용 임시)
 */
export const APP_MODE: AppMode = 'AUCTION' as AppMode; // 'SHOPPING'으로 변경 시 쇼핑몰 UI로 전환

/**
 * 현재 앱이 쇼핑몰 모드인지 확인
 */
export const isShoppingMode = (): boolean => {
  return APP_MODE === 'SHOPPING';
};

/**
 * 현재 앱이 경매 모드인지 확인
 */
export const isAuctionMode = (): boolean => {
  return APP_MODE === 'AUCTION';
};
